const FiveAAPrescribedContent = `

Prescribed authority for investment allowance.

5AA. For the purposes of sub-section (2B) of section 32A, the "prescribed authority" shall be the Secretary, Department of Scientific and Industrial Research  Government of India.


`;

export default FiveAAPrescribedContent;